<template>
  <el-form :model="form" label-width="120px" @submit.prevent="submitForm">
    <el-form-item label="Title">
      <el-input v-model="form.title" required @input="generateSlug"></el-input>
    </el-form-item>

    <el-form-item label="Slug" v-if="isAdminOrModerator">
      <el-input v-model="form.slug" required></el-input>
    </el-form-item>

    <el-form-item label="Content">
      <rich-text-editor v-model="form.content"></rich-text-editor>
    </el-form-item>

    <el-collapse>
      <el-collapse-item title="SEO Options">
        <el-form-item label="SEO Title">
          <el-input v-model="form.seo_title"></el-input>
        </el-form-item>

        <el-form-item label="Meta Description">
          <el-input type="textarea" v-model="form.meta_description"></el-input>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>

    <el-form-item>
      <el-button type="primary" native-type="submit">Submit</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import RichTextEditor from './RichTextEditor.vue'
import axios from 'axios'

export default {
  components: {
    RichTextEditor,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
    submitUrl: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isAdminOrModerator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        title: '',
        slug: '',
        content: '',
        seo_title: '',
        meta_description: '',
      },
    }
  },
  created() {
    Object.assign(this.form, this.initialData)
  },
  methods: {
    async submitForm() {
      try {
        let response;
        if (this.isEdit) {
          response = await axios.put(this.submitUrl, this.form)
        } else {
          response = await axios.post(this.submitUrl, this.form)
        }
        console.log('Form submitted successfully:', response.data)
        this.$emit('form-submitted', response.data)
        window.location.href = '/pages'
      } catch (error) {
        console.error('Error submitting form:', error)
        this.$emit('form-error', error)
        this.$message.error('An error occurred while submitting the form. Please try again.')
      }
    },
    generateSlug() {
      if (!this.isAdminOrModerator || !this.form.slug) {
        this.form.slug = this.form.title
          .toLowerCase()
          .replace(/[^\w ]+/g, '')
          .replace(/ +/g, '-')
      }
    }
  },
}
</script>